if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        arrowPrev: this.querySelector('.product-arrow-prev'),
        arrowNext: this.querySelector('.product-arrow-next')
      }
      this.mql = window.matchMedia('(min-width: 750px)');

      // Add listeners to arrows
      if (this.elements.arrowPrev) {
        this.elements.arrowPrev.addEventListener('click', this.onArrowClick.bind(this, 'prev'));
      }
      if (this.elements.arrowNext) {
        this.elements.arrowNext.addEventListener('click', this.onArrowClick.bind(this, 'next'));
      }

      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
       
       // Initial Check for arrow visibility
       const activeMedia = this.elements.viewer.querySelector('.is-active');
       if(activeMedia) this.updateOverlayArrows(activeMedia);
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    // Helper to determine if an element should be ignored in navigation
    shouldSkip(element) {
      if (!element) return false;
      // Ignores the class explicitly requested
      if (element.classList.contains('thumbnail-list_item--variant')) return true; 
      // Ignores the standard class for hidden variants on the main viewer
      if (element.classList.contains('product__media-item--variant')) return true; 
      const targetIds = ['template--24981570912530__main-44651005411602'];
      if (targetIds.includes(element.dataset.mediaId)) return true;
      return false;
    }

    onArrowClick(direction) {
      const activeMedia = this.elements.viewer.querySelector('.is-active');
      if (!activeMedia) return;

      let targetMedia;
      
      if (direction === 'prev') {
        targetMedia = activeMedia.previousElementSibling;
        // Keep going back if the sibling has the restricted class
        while(targetMedia && this.shouldSkip(targetMedia)) {
          targetMedia = targetMedia.previousElementSibling;
        }
      } else {
        console.log(activeMedia);
        targetMedia = activeMedia.nextElementSibling;
        console.log(targetMedia);

        // Keep going forward if the sibling has the restricted class
        while(targetMedia && this.shouldSkip(targetMedia)) {
          targetMedia = targetMedia.nextElementSibling;
        }
      }
      if (targetMedia && targetMedia.dataset.mediaId) {
        this.setActiveMedia(targetMedia.dataset.mediaId, false);
      }
    }

    setActiveMedia(mediaId, prepend) {
      console.log(this.elements.viewer);
      console.log(mediaId);

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      
      console.log(activeMedia);      
      
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');
      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      
      this.playActiveMedia(activeMedia);
      
      // Update Arrows on switch
      this.updateOverlayArrows(activeMedia);

      if (!this.elements.thumbnails) return;
      
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      
      Array.from(activeMedia.parentElement.children).forEach(child => {
        child.style.display = 'none';
      });

      // Set the specific element to display as a list-item
      activeMedia.style.display = 'list-item';
    }

    updateOverlayArrows(activeMedia) {
      if (!this.elements.arrowPrev || !this.elements.arrowNext) return;

      const performUpdate = () => {
         // Find valid previous sibling (skipping ignored classes)
         let prevItem = activeMedia.previousElementSibling;
         while(prevItem && this.shouldSkip(prevItem)) {
            prevItem = prevItem.previousElementSibling;
         }

         // Find valid next sibling (skipping ignored classes)
         let nextItem = activeMedia.nextElementSibling;
         while(nextItem && this.shouldSkip(nextItem)) {
            nextItem = nextItem.nextElementSibling;
         }

         // Show/Hide Previous Arrow
         if (!prevItem) {
           this.elements.arrowPrev.style.display = 'none';
         } else {
           this.elements.arrowPrev.style.display = 'flex';
         }

         // Show/Hide Next Arrow
         if (!nextItem) {
           this.elements.arrowNext.style.display = 'none';
         } else {
           this.elements.arrowNext.style.display = 'flex';
         }
      }
      
      requestAnimationFrame(performUpdate);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}